<span class="appointment-details-tag-wrapper zk-flex zk-items-center zk-gap-1">
	<p class="appointment-details-tag-label" freud-typography fontType="smallSemibold1-5">
		{{ label }}
	</p>
	<span 
		*ngIf="icon" 
		class="freud-icon appointment-details-tag freud-icon-sm"
		[ngClass]="'freud-icon-' + icon"
	>
	</span>
</span>